import { HttpStatusCode } from '@/utils';

export class UnexpectedError extends Error {
  status: HttpStatusCode;

  originalError: any;

  constructor(status?: HttpStatusCode, originalError?: any) {
    super('Ocorreu algum erro. Por favor, tente novamente mais tarde.');
    this.name = 'UnexpectedError';
    this.status = status;
    this.originalError = originalError;
  }
}
